import { createContext } from 'react';
import BuildingStore from './BuildingStore';
import BuildingDetailStore from './BuildingDetailStore';
import ModalStore from './ModalStore';
import CreateProjectStore from './CreateProjectStore';
import ProjectStore from './ProjectStore';
import TaskStore from './TaskStore';
import UIStore from './UIStore';
import UserStore from './UserStore';
import ProjectDetailStore from './ProjectDetailStore';
import ChatStore from './ChatStore';
import TaskEditorStore from './TaskEditorStore';
import SurveyStore from './SurveyStore';
// TODO change name to MapEditorStore
import EditorStore from './EditorStore';
import FeatureSettingsStore from './FeatureSettingsStore';
import MapStore from './MapStore';

export default createContext({
  buildingStore: BuildingStore,
  buildingDetailStore: BuildingDetailStore,
  modalStore: ModalStore,
  projectStore: ProjectStore,
  taskStore: TaskStore,
  uiStore: UIStore,
  userStore: UserStore,
  createProjectStore: CreateProjectStore,
  projectDetailStore: ProjectDetailStore,
  taskEditorStore: TaskEditorStore,
  mapStore: MapStore,
  editorStore: EditorStore,
  featureSettingsStore: FeatureSettingsStore,
  surveyStore: SurveyStore,
  chatStore: ChatStore
});
